import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M910.001 203.918C910.001 163.587 921.96 124.161 944.366 90.6273 966.773 57.0931 998.621 30.9565 1035.88 15.5225 1073.14.0883516 1114.15-3.9499 1153.7 3.91831 1193.26 11.7866 1229.59 31.2078 1258.11 59.7263 1286.63 88.2447 1306.05 124.579 1313.92 164.135 1321.78 203.692 1317.75 244.693 1302.32 281.954 1286.88 319.215 1260.74 351.062 1227.21 373.47 1193.68 395.876 1154.25 407.836 1113.92 407.836 1087.13 407.869 1060.6 402.617 1035.84 392.38 1011.09 382.144 988.596 367.124 969.654 348.182 950.712 329.241 935.692 306.748 925.457 281.993 915.22 257.237 909.967 230.706 910.001 203.918zM167.424 913.308 458.311 622.422H1045.04L460.789 1206.68C421.886 1245.58 369.124 1267.44 314.107 1267.44 259.09 1267.44 206.327 1245.58 167.424 1206.68 128.522 1167.77 106.667 1115.01 106.667 1059.99 106.667 1004.97 128.522 952.211 167.424 913.308zM1738.81 1027.77 1454.11 1313.21H867.136L1444.7 734.406C1483.6 695.405 1536.4 673.455 1591.49 673.386 1646.57 673.316 1699.43 695.132 1738.43 734.034 1777.43 772.936 1799.38 825.739 1799.45 880.826 1799.52 935.911 1777.71 988.769 1738.81 1027.77zM587.075 1602.79C564.668 1636.33 552.709 1675.75 552.709 1716.08 552.709 1770.16 574.192 1822.02 612.435 1860.27 650.677 1898.51 702.543 1920 756.627 1920 796.957 1920 836.382 1908.04 869.917 1885.63 903.451 1863.23 929.588 1831.38 945.021 1794.12 960.456 1756.85 964.494 1715.85 956.625 1676.29 948.758 1636.74 929.336 1600.4 900.817 1571.89 872.299 1543.37 835.965 1523.94 796.409 1516.08 756.853 1508.21 715.851 1512.25 678.59 1527.69 641.329 1543.12 609.481 1569.25 587.075 1602.79z"
});

var IconImpactLogoLine = /*#__PURE__*/function (_Component) {
  _inherits(IconImpactLogoLine, _Component);

  var _super = _createSuper(IconImpactLogoLine);

  function IconImpactLogoLine() {
    _classCallCheck(this, IconImpactLogoLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconImpactLogoLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconImpactLogo",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconImpactLogoLine.displayName = "IconImpactLogoLine";
  return IconImpactLogoLine;
}(Component);

IconImpactLogoLine.glyphName = 'impact-logo';
IconImpactLogoLine.variant = 'Line';
IconImpactLogoLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconImpactLogoLine;
export { IconImpactLogoLine };